import { FC } from 'react'
import css from 'classnames'
import { Props } from './types'
import { DeleteSVG } from '../SVG/DeleteSVG'
import { DropFileZone } from '../drop-file-zone'

export const ImagePreview: FC<Props> = ({
  src,
  alt,
  className,
  removeButtonClasses,
  imageClasses,
  onRemove,
  showDropzone = false,
  onUpload,
  isLoading,
  error,
  accept,
  dropzoneClassName,
  dropzoneText,
}) => {
  if (showDropzone && onUpload) {
    return (
      <DropFileZone
        accept={accept}
        onChange={onUpload}
        isLoading={isLoading}
        error={error}
        className={css(className, dropzoneClassName)}
        text={dropzoneText}
      />
    )
  }

  return (
    <div className={className}>
      <div className="relative inline-block max-w-full">
        {src ? (
          <img
            className={css(
              'w-full h-full object-cover rounded-lg',
              imageClasses,
            )}
            src={src}
            alt={alt}
          />
        ) : null}

        {src && onRemove ? (
          <div
            className={css(
              'w-8 h-8 rounded absolute top-2 right-2 bg-white border border-gray-400 flex items-center justify-center hover:bg-gray-400 transition-all cursor-pointer duration-75',
              removeButtonClasses,
            )}
            onClick={onRemove}
          >
            <DeleteSVG />
          </div>
        ) : null}
      </div>
    </div>
  )
}
